<form class="mce-form-section">

    <div class="mce-form-section-title">Supply System</div>

    <div class="mce-form-field-group">

        <div>
            <mat-form-field class="w-full">
                <mat-label>supply system</mat-label>
                <mat-select [formField]="form().case">
                    @for (option of caseOptions(); track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        @if (form().case().value() == 'dc') {
        <div>
            <mat-form-field>
                <mat-label>d.c. voltage</mat-label>
                <input matInput type="number" placeholder="d.c. voltage"
                       [formField]="form().v" />
                <span matSuffix>V</span>
                @for (error of form().v().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>
        }

        @if (form().case().value() == 'ac1ph') {

        <div>
            <mat-form-field>
                <mat-label>a.c. 1-phase voltage [L-N]</mat-label>
                <input matInput type="number" placeholder="a.c. 1-phase voltage"
                       [formField]="form().u0" />
                <span matSuffix>V</span>
                @for (error of form().u0().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>
        }

        @if (form().case().value() == 'ac3ph' || form().case().value() == 'tpn') {

        <div>
            <mat-form-field>
                <mat-label>a.c. 3-phase voltage</mat-label>
                <input matInput type="number" placeholder="a.c. 3-phase voltage"
                       [formField]="form().u" />
                <span matSuffix>V {{uToU0()}} </span>
                @for (error of form().u().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        }

        @if(form().case().value() != 'dc') {

        <div>
            <mat-form-field>
                <mat-label>frequency</mat-label>
                <input matInput type="number" placeholder="frequency"
                       [formField]="form().f" />
                <span matSuffix>Hz</span>
                @for (error of form().f().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>
        }

    </div>




</form>
